export default __webpack_public_path__ + "09a1ab78b38686960f7adde22acce60e.svg";